import axiosInstance from './AxiosInstance';

const FacilityTypeService = {
  fetchFacilityTypes: async (page, pageSize, sortBy, order, searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order,
      searchTerm: searchTerm?.trim() || "", 
    };
    
    try {
      const response = await axiosInstance.get('/facilitytype', {
        params: queryObj, 
      });
      console.log("response.data",response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching facility types:', error);
      throw error; // Propagate the error to be handled by the caller
    }
  },
  createFacilityTypes: async (data) => {
    try {
      const response = await axiosInstance.post('/facilitytype', data);
      return response.data;
    } catch (error) {
      console.error('Error creating FacilityType:', error);
      throw error;
    }
  },
  
  updateFacilityTypes: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/facilitytype/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating FaciliTytype with ID ${id}:`, error);
      throw error;
    }
  },
  
  deleteFacilityTypes: async (id) => {
    try {
      const response = await axiosInstance.delete(`/facilitytype/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting FacilityType with ID ${id}:`, error);
      throw error;
    }
  }
  };

export default FacilityTypeService;
